var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E14E1D;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#EBEBEB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,0h25.5C43,0,48,5,48,11.2v25.5C48,43,43,48,36.8,48H11.2C5,48,0,43,0,36.8V11.2C0,5,5,0,11.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,7.1l1.6,18.1h20.8L30.7,33L24,34.8L17.3,33l-0.4-5h-6l0.9,9.6L24,41l12.3-3.4l1.6-18.4H16.1l-0.5-6.1h22.9 h0l0.5-6H9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,7.1H9l1.6,18.1H24v-6h-7.9l-0.5-6.1H24V7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,34.8L24,34.8L17.3,33l-0.4-5h-6l0.9,9.6L24,41l0,0V34.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.cfc95566eb4ccb5ef28aa1264351e26b.svg";
export { ForwardRef as ReactComponent };